import { datadogLogs } from '@datadog/browser-logs';

import getEnvironmentVariables from '@/config/environment';

const DATADOG_SITE = 'datadoghq.com';
const DATADOG_SERVICE = 'pos-diner-app';

const datadog = () => {
  const { DATADOG_CLIENT_TOKEN, ENVIRONMENT_NAME, ENABLE_DATADOG, BUILD_ID } =
    getEnvironmentVariables();

  if (!ENABLE_DATADOG || !DATADOG_CLIENT_TOKEN) {
    return;
  }

  datadogLogs.init({
    clientToken: DATADOG_CLIENT_TOKEN,
    site: DATADOG_SITE,
    service: DATADOG_SERVICE,
    env: ENVIRONMENT_NAME,
    version: BUILD_ID,
    sessionSampleRate: 100,
    forwardConsoleLogs: 'all',
    forwardErrorsToLogs: true
  });
};

export default datadog;
